import { lazy } from "react";
import { RouteObject } from "react-router-dom";

const MarketsView = lazy(() => import("."));

export default [{ index: true, Component: MarketsView }] satisfies RouteObject[];
